import authLogin from './authLogin'
import graphConfig from './graphConfig'
import loginRequest from './loginRequest'

export default {
  authLogin,
  graphConfig,
  loginRequest,
}
